import axios from '../axios';
import { GET_MAP_ZIPCODE_BOUNDRIES } from '../ApiUrl';

const MAX_ZIPCODE_SEARCH = 100;

/**
 * Builds request body for GET/POST /GetMapZipcodeBoundries.
 * @param {string|string[]} zipcodes — comma-separated zips, zip array, or regional branch name
 */
function buildZipcodesBody(zipcodes) {
  if (Array.isArray(zipcodes)) {
    const list = zipcodes.map((z) => String(z ?? '').trim()).filter(Boolean);
    if (!list.length) return null;
    return { zipcodes: list };
  }
  const value = String(zipcodes ?? '').trim();
  if (!value) return null;
  return { zipcodes: value };
}

/**
 * POST /GetMapZipcodeBoundries
 * @param {{ zipcodes: string|string[] }} params
 */
export const getMapZipcodeBoundriesAPI = async ({ zipcodes } = {}) => {
  try {
    const body = buildZipcodesBody(zipcodes);
    if (!body) {
      return { hasError: true, message: 'zipcodes is required.' };
    }

    if (Array.isArray(body.zipcodes) && body.zipcodes.length > MAX_ZIPCODE_SEARCH) {
      return {
        hasError: true,
        message: `Maximum ${MAX_ZIPCODE_SEARCH} ZIP codes per search.`,
      };
    }

    if (typeof body.zipcodes === 'string') {
      const zipOnlyCount = body.zipcodes
        .split(/[,;\s]+/)
        .map((z) => z.replace(/\D/g, '').trim())
        .filter((z) => z.length >= 5).length;
      if (zipOnlyCount > MAX_ZIPCODE_SEARCH) {
        return {
          hasError: true,
          message: `Maximum ${MAX_ZIPCODE_SEARCH} ZIP codes per search.`,
        };
      }
    }

    const response = await axios.post(GET_MAP_ZIPCODE_BOUNDRIES, body);
    return response;
  } catch (error) {
    console.log('getMapZipcodeBoundriesAPI catch', error);
    return {
      hasError: true,
      message: error?.message || 'Failed to load map boundaries.',
    };
  }
};

export { MAX_ZIPCODE_SEARCH };
